import { render, staticRenderFns } from "./Issuu.vue?vue&type=template&id=95711412&scoped=true"
import script from "./Issuu.vue?vue&type=script&lang=js"
export * from "./Issuu.vue?vue&type=script&lang=js"
import style0 from "./Issuu.vue?vue&type=style&index=0&id=95711412&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95711412",
  null
  
)

export default component.exports